export default __webpack_public_path__ + "static/media/LogoDarkYes.98c6c0c6.png";